import { themeBackgrounds, themeColors } from "@dana/MobiusOverrides/styles/colors";
import { fontSizes, fontWeights, lineHeights } from "@dana/MobiusOverrides/styles/typography";
import { headerSignInStyles } from "@dana/Overrides/Widgets/Common/HeaderSignIn";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

headerSignInStyles.signOutWrapper = mergeToNew(headerSignInStyles.signOutWrapper, {
    css: css`
        display: flex;
        align-items: center;

        .create-account-title {
            gap: 4px;
        }

        .menu-active {
            [data-test-selector="header_signIn"] {
                 &.userAuthenticated {
                    svg {
                        path {
                            fill: ${themeColors.secondary.danaBrightBlue};
                        }
                    }
                }
                .myaccount-user-loggedin-wrapper {
                    [data-test-selector="header_userName"] {
                        color: ${themeColors.secondary.danaBrightBlue};

                        ::after {
                            background: ${themeColors.secondary.danaBrightBlue};
                        }
                    }

                    .create-account-title {
                        color: ${themeColors.secondary.danaBrightBlue};
                        gap: 4px;
                        .create-account-icon {
                            transform: rotate(180deg);
                            svg {
                                color: ${themeColors.secondary.danaBrightBlue};
                            }
                        }
                    }
                }
            }
        }

        &:hover {

            ${IconWrapper} {
                svg {
                    path {
                        fill: ${themeColors.secondary.danaBrightBlue};
                    }
                }
            }

            [data-test-selector="header_signIn"] {
                &.userAuthenticated {
                    svg {
                        path {
                            fill: ${themeColors.secondary.danaBrightBlue};
                        }
                    }
                }
                &::after {
                    background: ${themeColors.secondary.danaBrightBlue};
                }
            }
        }

        [data-test-selector="header_signIn"] {
            position: relative;
            &::after {
                content: "";
                position: absolute;
                right: 0px;
                top: 50%;
                transform: translateY(-50%);
                width: 1px;
                height: 14px;
                background: ${themeColors.primary.white};

                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                display: none;
                            `,
                            null,
                            null,
                        ],
                        "max",
                    )}
            }
        }

        &.for-authenticated {
            [data-test-selector="header_signIn"] {
                &::after {
                    content: none;
                }
            }
        }

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        &.for-guest {
                            [data-test-selector="header_createAccount"] {
                                display: none;
                            }
                        }
                    `,
                    css`
                        &.for-guest {
                            [data-test-selector="header_createAccount"] {
                                display: none;
                            }
                        }
                    `,
                    css`
                        &.for-guest {
                            [data-test-selector="header_createAccount"] {
                                display: flex;
                                padding-left: 8px;
                            }
                        }
                    `,
                    css`
                        &.for-guest {
                            [data-test-selector="header_createAccount"] {
                                display: flex;
                                padding-left: 8px;
                            }
                        }
                    `,
                    css`
                        &.for-guest {
                            [data-test-selector="header_createAccount"] {
                                display: flex;
                                padding-left: 8px;
                            }
                        }
                    `,
                ],
                "min",
            )}
    `,
});

headerSignInStyles.signInWrapper = mergeToNew(headerSignInStyles.signInWrapper, {
    css: css`
        display: flex;
        align-items: center;

        &:hover {
            ${TypographyStyle} {
                color: ${themeColors.secondary.danaBrightBlue};
            }

            [data-test-selector="header_userName"] {
                &::after {
                    background: ${themeColors.secondary.danaBrightBlue};
                }
            }
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: flex;
                    `,
                    css`
                        display: flex;
                    `,
                    css`
                        display: flex;
                    `,
                ],
                "min",
            )}

        [data-test-selector="header_userName"] {
            position: relative;
            &::after {
                content: "";
                position: absolute;
                right: 0px;
                top: 50%;
                transform: translateY(-50%);
                width: 1px;
                height: 14px;
                background: ${themeColors.primary.white};

                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                display: none;
                            `,
                            null,
                            null,
                        ],
                        "max",
                    )}
            }
        }
    `,
});

headerSignInStyles.titleClickable = mergeToNew(headerSignInStyles.titleClickable, {
    css: css`
        color: ${themeColors.primary.white};
        column-gap: 8px       
        position: relative;

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        ${TypographyStyle} {
                            display: none;
                        }
                    `,
                    css`
                        ${TypographyStyle} {
                            display: none;
                        }
                    `,
                    null,
                    null,
                ],
                "max",
            )}

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        &.for-guest {
                            [data-test-selector="header_signIn"] {
                                padding-right: 0px;
                                margin-right: 0px;
                            }
                        }
                    `,
                    css`
                        &.for-guest {
                            [data-test-selector="header_signIn"] {
                                padding-right: 0px;
                                margin-right: 0px;
                            }
                        }
                    `,
                    css`
                        column-gap: 8px;

                        &.for-guest {
                            [data-test-selector="header_signIn"] {
                                padding-right: 8px;
                                margin-right: 0px;
                            }
                        }
                    `,
                    css`
                        column-gap: 8px;

                        &.for-guest {
                            [data-test-selector="header_signIn"] {
                                padding-right: 8px;
                                margin-right: 0px;
                            }
                        }
                    `,
                    css`
                        column-gap: 8px;

                        &.for-guest {
                            [data-test-selector="header_signIn"] {
                                padding-right: 8px;
                                margin-right: 0px;
                            }
                        }
                    `,
                ],
                "min",
            )}    

        > ${IconWrapper} {
            &.userAuthenticated {
                svg {
                    path {
                        fill: ${themeColors.secondary.danaBrightBlue};
                    }
                }
            }
        }
    `,
});

headerSignInStyles.titleIcon = mergeToNew(headerSignInStyles.titleIcon, {
    size: 18,
    css: css`
        &.userAuthenticated {
            svg {
                path {
                    fill: ${themeColors.secondary.danaBrightBlue};
                }
            }
        }
    `,
});

headerSignInStyles.titleTypography = mergeToNew(headerSignInStyles.titleTypography, {
    size: fontSizes.small,
    lineHeight: lineHeights.defaultMedium,
    weight: fontWeights.medium,
    color: themeColors.primary.white,
    css: css`
        display: block;

        padding-right: 8px;
        margin-right: 8px;
        position: relative;

        &:first-child {
            &::after {
                content: "";
                position: absolute;
                right: 0px;
                top: 50%;
                transform: translateY(-50%);
                width: 1px;
                height: 14px;
                background: ${themeColors.primary.white};
            }
        }

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        padding-right: 0px;
                        margin-right: 0px;
                    `,
                    css`
                        padding-right: 0px;
                        margin-right: 0px;
                    `,
                    css`
                        padding-right: 8px;
                        margin-right: 8px;
                    `,
                    css`
                        padding-right: 8px;
                        margin-right: 8px;
                    `,
                    css`
                        padding-right: 8px;
                        margin-right: 8px;
                    `,
                ],
                "min",
            )}
    `,
});

headerSignInStyles.createAccountTitle = mergeToNew(headerSignInStyles.createAccountTitle, {
    size: fontSizes.small,
    lineHeight: lineHeights.defaultMedium,
    color: themeColors.primary.white,
    weight: fontWeights.medium,
    css: css`
        display: flex;
        align-items: center;

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        padding-right: 0px;
                        margin-right: 0px;
                    `,
                    css`
                        padding-right: 0px;
                        margin-right: 0px;
                    `,
                    css`
                        padding-right: 8px;
                        margin-right: 0px;
                    `,
                    css`
                        padding-right: 8px;
                        margin-right: 0px;
                    `,
                    css`
                        padding-right: 8px;
                        margin-right: 0px;
                    `,
                ],
                "min",
            )}
    `,
});

headerSignInStyles.signOutClickable = mergeToNew(headerSignInStyles.signOutClickable, {
    css: css`
        color: ${themeColors.primary.white};
    `,
});

headerSignInStyles.menuHeaderListStyle = mergeToNew(headerSignInStyles.menuHeaderListStyle, {
    cssOverrides: {       
        menuItem: css`
            width: 100%;
            border-bottom: 1px solid ${themeBackgrounds.lightGray};

            &:last-child {
                border-bottom: none;
            }

            &:hover {
                background: ${themeBackgrounds.lightGray};
                text-decoration: none;
            }

            a {
                padding: 4px 8px;
                min-height: auto;
                justify-content: space-between;
                color: ${themeColors.primary.danaBlue};

                &:hover {
                    text-decoration: none;
                    color: ${themeColors.secondary.danaDarkBlue};
                    background: ${themeBackgrounds.offWhite};

                    ::before {
                        background: none;
                    }
                }

                &:focus {
                    outline: none;
                    border-radius: 0;
                    text-decoration: none;
                    color: ${themeColors.primary.richBlack};
                    background: ${themeBackgrounds.lightGray};
                }

                &:focus-visible {
                    outline: none;
                    outline-offset: 0px;
                    border-radius: 0px;
                    text-decoration: none;
                    color: ${themeColors.primary.richBlack};
                    background: ${themeBackgrounds.lightGray};
                }

                .user-icon {
                    display: none;
                }

                .user-icon + span[class*="TypographyStyle"] {
                    color: ${themeColors.primary.danaBlue};
                }
            }

            button {
                padding: 4px 8px;
                min-height: auto;
                width: 100%;
                justify-content: space-between;

                &:hover {
                    text-decoration: none;
                    color: ${themeColors.secondary.danaDarkBlue};
                    background: ${themeBackgrounds.offWhite};
                }

                &:focus {
                    outline: none;
                    border-radius: 0;
                    text-decoration: none;
                    color: ${themeColors.primary.richBlack};
                    background: ${themeBackgrounds.lightGray};
                }

                &:focus-visible {
                    outline: none;
                    outline-offset: 0px;
                    border-radius: 0px;
                    text-decoration: none;
                    color: ${themeColors.primary.richBlack};
                    background: ${themeBackgrounds.lightGray};
                }

                .user-icon {
                    display: none;
                }

                .user-icon + span[class*="TypographyStyle"] {
                    color: ${themeColors.primary.danaBlue};
                }

                .right-chevron {
                    display: none;
                }
            }
        `,

        menu: css`
            border-bottom-left-radius: 0px;
            border-bottom-right-radius: 0px;
            width: 300px;
            padding: 8px;
            border: none;
            right: 0;
            top: 32px;
        `,
    },
});
